import Router from 'vue-router';
import { getFrameworkRoutes } from './framework/framework_routes';
import { getApplicationRoutes } from './application/application_routes';

export default new Router({
    routes: getApplicationRoutes().concat(getFrameworkRoutes()),
});
